var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    #Spinner{transform-origin:center;animation:spinner_inner .8s step-end infinite}@keyframes \n    spinner_inner{\n      12.5%{transform:rotate(45deg)}\n      25%{transform:rotate(90deg)}\n      37.5%{transform:rotate(135deg)}\n      50%{transform:rotate(180deg)}\n      62.5%{transform:rotate(225deg)}\n      75%{transform:rotate(270deg)}\n      87.5%{transform:rotate(315deg)}\n      100%{transform:rotate(360deg)}\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spinner"
  }, /*#__PURE__*/React.createElement("rect", {
    id: 325,
    opacity: 0.87,
    x: 13.3787,
    y: 10.0503,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(135 13.3787 10.0503)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: 270,
    opacity: 0.75,
    x: 10.5,
    y: 13,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(90 10.5 13)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: 225,
    opacity: 0.63,
    x: 10.5508,
    y: 17.1213,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(45 10.5508 17.1213)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: 180,
    opacity: 0.51,
    x: 13.5,
    y: 20,
    width: 4,
    height: 10,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: 135,
    opacity: 0.39,
    x: 27.5234,
    y: 24.1924,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(135 27.5234 24.1924)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: 90,
    opacity: 0.27,
    x: 30.5,
    y: 13,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(90 30.5 13)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: 45,
    opacity: 0.15,
    x: 24.6953,
    y: 2.97925,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(45 24.6953 2.97925)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: 0,
    x: 13.5,
    width: 4,
    height: 10,
    rx: 2,
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.57cecac959e1eeaccf3a6f669012fa99.svg";
export { ForwardRef as ReactComponent };